<template>
  <b-modal
    id="settingsItemModal"
    ref="settingsItemModal"
    title="Opções"
    size="xl"
    centered
    hide-footer
    @close="$emit('onClose')"
    @hide="$emit('onClose')"
  >
    <template>
      <template v-if="activeSettingsItem.frameType === 'button'">
        <form action="#" @submit="handleUpdateEditButton">
          <div class="row">
            <!-- <div class="col-12 form-group">
              <label>Título</label>
              <input
                v-model="activeSettingsItem.frameContent.title"
                class="form-control"
                type="text"
              />
            </div> -->
            <div class="col-12 form-group">
              <label>Texto do botão</label>
              <input
                v-model="activeSettingsItem.frameContent.text"
                class="form-control"
                type="text"
                required
              />
            </div>
            <div class="col-6 form-group">
              <label>Tipo de botão</label>
              <select
                class="form-control"
                id="select-type-buttom"
                v-model="activeSettingsItem.frameContent.settings.type"
              >
                <option value="url">URL</option>
                <option value="whatsapp">Whatsapp</option>
              </select>
            </div>
            <div
              class="col-6 form-group"
              v-if="
                activeSettingsItem &&
                activeSettingsItem.frameContent.settings.type == 'url'
              "
            >
              <label>Abrir em</label>
              <select
                class="form-control"
                id="select-target-buttom"
                v-model="activeSettingsItem.frameContent.settings.target"
              >
                <option value="_blank">Nova aba</option>
                <option value="_self">Mesma aba</option>
              </select>
            </div>
          </div>
          <div
            class="row"
            v-if="
              activeSettingsItem &&
              activeSettingsItem.frameType == 'button' &&
              activeSettingsItem.frameContent.settings.type == 'url'
            "
          >
            <div class="col-12 form-group">
              <label>URL</label>
              <input
                v-model="activeSettingsItem.frameContent.ref"
                type="url"
                name
                id="URL-input"
                class="form-control"
                placeholder="url com https"
                required
              />
            </div>
          </div>
          <div
            class="row"
            v-if="
              activeSettingsItem &&
              activeSettingsItem.frameType == 'button' &&
              activeSettingsItem.frameContent.settings.type == 'whatsapp'
            "
          >
            <div class="col-4 form-group">
              <label>DDI</label>
              <input
                type="number"
                v-model="activeSettingsItem.frameContent.dataPhone.idd"
                class="form-control"
                placeholder="DDI"
                required
                id="IDD-input"
              />
            </div>
            <div class="col-8 form-group">
              <label>DDD + Numero</label>
              <input
                v-model="activeSettingsItem.frameContent.dataPhone.phone"
                v-mask="'###########'"
                type="tel"
                class="form-control"
                placeholder="DDD+Número"
                required
              />
            </div>
          </div>
          <div
            class="row"
            v-if="
              activeSettingsItem && activeSettingsItem.frameType == 'button'
            "
          >
            <div class="col-12 form-group">
              <label>Modelo de botão</label>
              <select
                class="form-control"
                v-model="activeSettingsItem.frameContent.settings.size"
              >
                <option value="normal">Automático</option>
                <option value="btn-block">Linha completa</option>
              </select>
            </div>
          </div>
          
          <setting-frame-width
              :item="activeSettingsItem"
              @onChangeWidth="handleWidthChange"
          />

          <div class="mt-3 row justify-content-end">
            <div class="col-auto">
              <button type="submit" class="btn btn-primario py-2">
                Salvar
              </button>
            </div>
          </div>
        </form>
      </template>

      <!--
      <template v-else-if="activeSettingsItem.frameType === 'image'">
        <setting-frame-width
            :item="activeSettingsItem"
            @onChangeWidth="handleWidthChange"
        />

        <input
          type="file"
          ref="uploadPictureBeImageFrame"
          multiple
          hidden
          accept=".png, .jpeg, .gif, .jpg"
          id="uploadPictureBeImageFrame"
          @change="handleUpdatePictureImageFrame"
        />
        <div class="row justify-content-center">
          <div class="col-7 col-lg-5 text-center">
            <p class="mb-2">Prévia de imagem</p>
            <img
              @click="handleUploadImageFrame"
              :src="mountImageUrl(activeSettingsItem.frameContent)"
              class="img-fluid rounded pointer"
              alt
            />
          </div>
          <div class="w-100"></div>
          <div class="col-10 mt-2">
            <label for="actionItem" class="font-14">
              <small>Ação</small>
            </label>
            <select
              name="actionItem"
              id="actionItem"
              class="form-control"
              v-model="activeSettingsItem.actionType"
            >
              <option value="0">Nenhuma ação</option>
              <option value="1">Link na mesma aba</option>
              <option value="2">Link em nova aba</option>
            </select>
          </div>
          <div class="col-10 mt-3">
            <input
              type="text"
              placeholder="url (com https)"
              class="form-control"
              v-model="activeSettingsItem.action"
            />
          </div>
        </div>

        <p class="d-flex mt-3 float-right">
          <button
            class="btn btn-secundario py-2 mr-5"
            @click="$emit('transformInGallery', activeSettingsItem)"
          >
            Transformar em galeria
          </button>

          <button class="btn btn-primario py-2" @click="saveItemChanges">
            Salvar
          </button>
        </p>
      </template>
      -->
      <settings-frame-image
        v-else-if="activeSettingsItem.component === 'maincontent' && activeSettingsItem.frameType === 'image'"
        :item="activeSettingsItem"
        @saveItemChanges="handleSaveItemChanges"
        @transformInGallery="$emit('transformInGallery', activeSettingsItem)"
        @onClose="$emit('onClose')"
      />

      <template v-else-if="activeSettingsItem.frameType === 'beforeAfterImage'">
        <setting-frame-width
            :item="activeSettingsItem"
            @onChangeWidth="handleWidthChange"
        />

        <input
          type="file"
          ref="uploadPictureBefore"
          multiple
          hidden
          accept=".png, .jpeg, .gif, .jpg"
          id="uploadPictureBefore"
          @change="handleUpdatePictureBefore"
        />
        <input
          type="file"
          ref="uploadPictureAfter"
          multiple
          hidden
          accept=".png, .jpeg, .gif, .jpg"
          id="uploadPictureAfter"
          @change="handleUpdatePictureAfter"
        />
        <div class="row justify-content-center">
          <div class="col-6 text-center">
            <div class="leftImage">
              <p>Imagem esquerda</p>
              <template
                v-if="
                  activeSettingsItem.frameContent.beforePicture !=
                  `https://uli-pictures.s3-sa-east-1.amazonaws.com/panel/before-after-mockup-1.jpg`
                "
              >
                <img
                  class="img-fluid pointer"
                  :src="
                    mountImageUrl(activeSettingsItem.frameContent.beforePicture)
                  "
                  @click="handleUploadBeforePicture"
                />
              </template>
              <template v-else>
                <div
                  class="
                    d-flex
                    align-items-center
                    justify-content-center
                    pointer
                  "
                  @click="handleUploadBeforePicture"
                >
                  <span>
                    <i class="fal fa-camera fa-2x"></i>
                    <br />
                    <small>Adicionar</small>
                  </span>
                </div>
              </template>
            </div>
          </div>
          <div class="col-6 text-center">
            <div class="leftImage">
              <p>Imagem direita</p>
              <template
                v-if="
                  activeSettingsItem.frameContent.afterPicture !=
                  `https://uli-pictures.s3-sa-east-1.amazonaws.com/panel/before-after-mockup-2.jpg`
                "
              >
                <img
                  class="img-fluid cursor"
                  :src="
                    mountImageUrl(activeSettingsItem.frameContent.afterPicture)
                  "
                  @click="handleUploadAfterPicture"
                />
              </template>
              <template v-else>
                <div
                  class="
                    d-flex
                    align-items-center
                    justify-content-center
                    pointer
                  "
                  @click="handleUploadAfterPicture"
                >
                  <span>
                    <i class="fal fa-camera fa-2x"></i>
                    <br />
                    <small>Adicionar</small>
                  </span>
                </div>
              </template>
            </div>
          </div>
        </div>

        <p class="d-flex mt-3 float-right">
          <button class="btn btn-primario py-2" @click="saveItemChanges">
            Salvar
          </button>
        </p>
      </template>

      <settings-frame-gallery 
        v-else-if="activeSettingsItem.component === 'maincontent' && activeSettingsItem.frameType === 'gallery'"
        :item="activeSettingsItem"
        @saveItemChanges="handleSaveItemChanges"
        @onClose="$emit('onClose')"
      />

      <settings-frame-text
        v-else-if="activeSettingsItem.component === 'maincontent' && activeSettingsItem.frameType === 'text'"
        :item="activeSettingsItem"
        @saveItemChanges="handleSaveItemChanges"
        @onClose="$emit('onClose')"
      />

      <settings-frame-container
        v-else-if="activeSettingsItem.component === 'maincontent' && activeSettingsItem.frameType === 'container'"
        :item="activeSettingsItem"
        @saveItemChanges="handleSaveItemChanges"
        @onClose="$emit('onClose')"
      />

      <template v-else>
        <setting-frame-width
            :item="activeSettingsItem"
            @onChangeWidth="handleWidthChange"
        />

        <p class="d-flex mt-3 float-right">
          <button class="btn btn-primario py-2" @click="saveItemChanges">
            Salvar
          </button>
        </p>
      </template> 
    </template>
  </b-modal>
</template>


<script>
import uploadFiles from "@/mixins/uploadFiles";
import { mapGetters, mapState } from "vuex";

import SettingsFrameGallery from "../molecules/SettingsFrameGallery.vue";
import SettingFrameWidth from '../atoms/SettingFrameWidth.vue';
import SettingsFrameText from '../molecules/SettingsFrameText.vue';
import SettingsFrameContainer from '../molecules/SettingsFrameContainer.vue';
import SettingsFrameImage from '../molecules/SettingsFrameImage.vue';

export default {
  name: "ModalSettingsFrame",
  data() {
    return {
      activeSettingsItem: {},
      activeSettingsItemIndex: null,
    };
  },
  mixins: [uploadFiles],
  props: {
    activeItem: {
      type: Object,
      required: true,
    },
    settingsItemModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    itemIndex: {
      required: true,
    },
    pageFrameIndex: {
      required: true,
    },
  },
  components: { 
    SettingsFrameGallery,
    SettingsFrameText,
    SettingsFrameContainer,
    SettingFrameWidth,
    SettingsFrameImage
  },
  created() {},
  watch: {
    settingsItemModal() {
      if (this.settingsItemModal) {
        this.$refs.settingsItemModal.show();
      } else {
        this.$refs.settingsItemModal.hide();
        this.$emit("onClose");
      }
    },
    activeItem() {
      this.activeSettingsItem = this.activeItem;
    },
    itemIndex() {
      this.activeSettingsItemIndex = this.itemIndex;
    },
    pageFrameIndex() {
      this.$store.commit(
        "dashboardModule/updatePageIndex",
        this.pageFrameIndex
      );
    },
  },
  computed: {
    ...mapGetters("dashboardModule", [
      "loadingStatus"
    ])
  },
  methods: {
    // clearSettings() {
    //   this.activeSettingsItemIndex = null;
    //   this.activeSettingsItem = {};
    // },
    // SOMENTE PARA FUNCIIONAR OS DEMAIS FRAMES, QUANDO CADA UM TIVER SEU COMPONENTE DE CONFIGURAÇÃO
    // SERÁ NECESSARIO REMOVER DAQUI E COLOCAR NO COMPONENTE DE CONFIGURAÇÃO
    handleWidthChange(item) {
      this.activeSettingsItem.grid = item.grid;
      this.activeSettingsItem.gridMobile = item.gridMobile;
    },
    handleUpdateEditButton(e) {
      this.$store.dispatch("dashboardModule/UPDATE_FRAME", [
        this.pageFrameIndex,
        this.activeSettingsItemIndex,
        this.activeSettingsItem,
      ]);
      this.$emit("activeSettings", this.activeSettingsItem);
      this.$refs.settingsItemModal.hide();
      this.$emit("onClose");
      e.preventDefault();
    },
    handleUploadImageFrame() {
      this.$refs.uploadPictureBeImageFrame.click();
    },
    async handleUpdatePictureImageFrame() {
      const files = this.$refs.uploadPictureBeImageFrame.files;
      if (files) {
        let pictures = await this.uploadImages(files);
        this.activeSettingsItem.frameContent = pictures[0];
      } else {
        alert("Nenhum arquivo selecionado.");
      }
    },
    mountImageUrl(image) {
      return `${process.env.CDN_URL}${image}`;
    },
    handleUploadBeforePicture() {
      this.$refs.uploadPictureBefore.click();
    },
    async handleUpdatePictureBefore() {
      this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [true]);
      const files = this.$refs.uploadPictureBefore.files;
      if (files) {
        let pictures = await this.uploadImages(files);
        this.activeSettingsItem.frameContent.beforePicture = pictures[0];
        this.$emit("activeSettings", this.activeSettingsItem);
        this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [false]);
      } else {
        alert("Nenhum arquivo selecionado.");
      }
    },
    handleUploadAfterPicture() {
      this.$refs.uploadPictureAfter.click();
    },
    async handleUpdatePictureAfter() {
      this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [true]);
      const files = this.$refs.uploadPictureAfter.files;
      if (files) {
        let pictures = await this.uploadImages(files);
        this.activeSettingsItem.frameContent.afterPicture = pictures[0];
        this.$emit("activeSettings", this.activeSettingsItem);
        this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [false]);
      } else {
        alert("Nenhum arquivo selecionado.");   
      }
    },
    handleSaveItemChanges(item, close = true) {
      this.$store.dispatch("dashboardModule/UPDATE_FRAME", [
        this.pageFrameIndex,
        this.activeSettingsItemIndex,
        item,
      ]);
      if (close) {
        this.$refs.settingsItemModal.hide();
        this.$emit("onClose");
      }
      this.$emit("activeSettings", item);
    },
    // função antiga para funcionar com os demais frames sem ter feito o componente
    // de configuração para cada, igual foi feito para a galeria (só para os demais funcionar)
    saveItemChanges() {
      this.$store.dispatch("dashboardModule/UPDATE_FRAME", [
        this.pageFrameIndex,
        this.activeSettingsItemIndex,
        this.activeSettingsItem,
      ]);
      this.$refs.settingsItemModal.hide();
      this.$emit("onClose");
      this.$emit("activeSettings", this.activeSettingsItem);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/organisms/ModalSettingsFrame.vue